<template>
    <!-- news sources -->
    <div class="p-col-12 p-md-9 p-mx-auto p-mt-2">
        <div class="p-jc-center p-pt-4">
            <Button
                label="Create"
                icon="pi pi-plus"
                v-show="showCreateButton"
                @click="toggleNewsForm()"
                class="p-button-raised p-button p-button-text" />

            <Button
                v-for="item in newsSources"
                :key="item.id"
                v-bind:label="item.name"
                class="p-button-raised p-mx-2"
                v-bind:value="item.id" v-bind:ref="item.id"
                v-bind:class="{ 'p-button': this.selectedNewsSource === item.id, 'p-button-text': this.selectedNewsSource !== item.id }"
                @click="newsSourceSelected($event)" />
        </div>
        <div class="p-mt-2 p-text-left">
            <Button
                v-for="item in newsSourcesSubCategories"
                :key="item.id"
                :label="item.title"
                @click="newsSourceSubCategorySelected(item.id, item.source)"
                class="p-button-sm p-button p-button-text" />
        </div>
    </div>

    <!-- news form -->
    <!-- <transition name="expand"> -->
    <Dialog modal maximizable v-model:visible="isNewsFormVisible" class="p-col-12 p-md-10 p-mx-auto"
        :header="newsForm.mode === 'edit' ? 'Update News' : 'Add News'">
        <div class="p-grid">
            <div class="p-mx-auto box">
                <div class="p-fluid p-formgrid p-grid p-text-left">
                    <div class="p-field p-col-12 p-md-6">
                        <label for="img_url">Image Url</label>
                        <InputText id="img_url" type="text" v-model="newsForm.img_url" />
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="video_url">Video Url</label>
                        <InputText id="video_url" type="text" v-model="newsForm.video_url" />
                    </div>
                    <div class="p-field p-col-12">
                        <label for="title">Title</label>
                        <InputText id="title" type="text" v-model="newsForm.title" />
                    </div>
                    <div class="p-field p-col-12">
                        <label for="subtitle">Subtitle</label>
                        <Textarea class="resizable_textarea" id="subtitle" rows="2" :autoResize="true" v-model="newsForm.subtitle" />
                    </div>
                    <div class="p-field p-col-12">
                        <div class="flex align-items-center">
                            <Checkbox v-model="newsForm.middle_page_ad_enabled" id="middle_page_ad_enabled" name="middle_page_ad_enabled" :binary="true" />
                            <label for="middle_page_ad_enabled" class="p-ml-2"> 
                                <img class="icon-mini" src="../assets/admob-icon.png" /> Middle Page Ad Enabled (Ad is visible between subtitle and news content)
                            </label>
                        </div>
                    </div>
                    <div class="p-field p-col-12">
                        <label for="content">News content</label>
                        <Textarea class="" id="content" :autoResize="true" v-model="newsForm.content" />
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                        <label for="teams">Team Selection (max. 2)</label>
                        <AutoComplete id="teams"
                            aria-describedby="teams-help"
                            forceSelection
                            v-model="selectedTeams"
                            :multiple="true"
                            :dropdown="(selectedTeams !== null && selectedTeams.length < 2)"
                            :delay="200"
                            :suggestions="filteredTeams"
                            @complete="searchTeams($event)" field="name" />
                        <small id="teams-help">First two teams are saved. Others ignored</small>
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                        <label for="teams">Event Selection</label>
                        <Button :label="popupEventSelection.selectedEvent?.event_info ?? 'Select Event'" @click="popupSelectEvent()" />
                        <div v-show="popupEventSelection.selectedEvent?.event_info !== undefined && popupEventSelection.selectedEvent?.event_info !== null">
                            <br/>
                            <div class="p-field p-col-12">
                                <div class="align-items-center">
                                    <Checkbox v-model="newsForm.event_image_enabled" id="event_image_enabled" name="event_image_enabled" @change="eventImageEnabledChanged()" :binary="true" />
                                    <label for="event_image_enabled" class="p-ml-2"> 
                                        Enable Event Image
                                    </label>
                                </div>
                                <br/>
                                <div v-show="newsForm.event_image_enabled" class="align-items-center">
                                    <Dropdown v-model="newsEventImage.selected" :options="newsEventImage.items" optionLabel="name" placeholder="Select Background" class="w-full md:w-14rem">
                                        <template #value="image">
                                            <div v-if="image.value.id === 999 || (image.value !== null && image.value.path !== undefined && image.value.path !== null)" class="flex align-items-center">
                                                <img :src="image.value.path" :class="`mr-2`" style="width: 64px" />
                                            
                                                <span v-if="image.value.id !== 999" class="p-ml-2" v-show="image.value.name.length > 0" style="position: relative; bottom: 15px">
                                                    {{image.value.name}}
                                                </span>
                                                <span v-else class="p-ml-2" v-show="image.value.name.length > 0">
                                                    {{image.value.name}}
                                                </span>
                                            </div>
                                            <span v-else>
                                                {{image.placeholder}}
                                            </span>
                                        </template>
                                        <template #option="image">
                                            <div class="flex align-items-center">
                                                <div v-if="image.option.path !== undefined && image.option.path !== null" class="flex align-items-center">
                                                    <img :src="image.option.path" :class="`mr-2`" style="width: 120px" />
                                                
                                                    <span class="p-ml-2" v-show="image.option.name.length > 0" style="position: relative; bottom: 35px">
                                                        {{image.option.name}}
                                                    </span>
                                                </div>
                                                <span v-else>
                                                    {{image.option.name}}
                                                </span>
                                            </div>
                                        </template>
                                    </Dropdown>
                                    <div class="p-mt-4" v-show="newsEventImage.selected.id === 999">
                                        <div class="p-grid p-text-left">
                                            <div class="p-field p-col-12">
                                                <label for="custom_background">Custom Background</label>
                                                <InputText id="custom_background" type="text" v-model="newsEventImage.selected.background_url" />
                                            </div>
                                            <div class="p-field p-col-12" v-show="newsEventImage.selected.background_url !== null && newsEventImage.selected.background_url !== undefined && newsEventImage.selected.background_url !== ''">
                                                <Image imageClass="notification-picture p-d-inline" style="width:100% !important;" preview :src="newsEventImage.selected.background_url" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="insert-photo-gallery">&nbsp;</label> <br />
                        <div class="p-grid p-ai-center vertical-container">
                            <div class="p-col">
                                <Button 
                                    label="Insert Photo Gallery"
                                    @click="insertPhotoGallery()"
                                    icon="pi pi-images"
                                    class="p-button-outlined p-button-info p-button-text" />
                            </div>
                            <div class="p-col">
                                <Button 
                                    label="Create Notification"
                                    @click="toggleNotificationForm()"
                                    v-show="newsForm.mode === 'add' || (newsForm.has_notification === false)"
                                    icon="pi pi-bell"
                                    class="p-button-outlined p-button-info p-button-text" />
                            </div>
                        </div>
                    </div>
                </div>
                <div v-show="isCreateNotificationFormVisible" class="box" style="">
                    <h3>Create Notification</h3>
                    <div class="p-grid p-ai-top">
                        <div class="p-col-12 p-md-12 p-mb-3">
                            <Image imageClass="notification-picture p-d-inline" preview
                                style="width:100% !important;"
                                :src="newsNotification.img_url !== null && newsNotification.img_url !== undefined 
                                    && newsNotification.img_url.length > 0 ? newsNotification.img_url : newPictureDefaultPlaceholder"/>
                        </div>
                        
                        <div class="p-col-12 p-md-3">
                            <span class="p-float-label">
                                <InputText id="img_url" type="text" v-model="newsNotification.img_url" style="width: 96%;" />
                                <label for="img_url">Image URL</label>
                            </span>
                        </div>

                        <div class="p-col-12 p-md-3">
                            <span class="p-float-label">
                                <Textarea id="title" type="text" rows="3" :autoResize="true" v-model="newsNotification.title" style="width: 96%;" />
                                <label for="title">Title</label>
                            </span>
                        </div>

                        <div class="p-col-12 p-md-3">
                            <span class="p-float-label">
                                <Textarea class="" id="subtitle" rows="3" :autoResize="true" v-model="newsNotification.subtitle" style="width: 96%;" />
                                <label for="subtitle">Subtitle</label>
                            </span>
                        </div>

                        <div class="p-col-12 p-md-3">
                            <MultiSelect class="" id="notification_categories"
                                v-model="newsSelectedNotificationCategories" :options="notificationCategories" :filter="true"
                                optionLabel="name" placeholder="Select Categories"
                                style="padding:0 !important; width:96% !important;" />
                        </div>
                    </div>
                </div>
                <div v-show="isPictureGalleryFormVisible" class="news-gallery p-mt-4 box" style="display:flex; height:350px; overflow:auto;">
                    <div class="p-ml-1 p-mr-1">
                        <Image imageClass="gallery-picture p-d-inline" preview
                            :src="newPicture.img_url !== null && newPicture.img_url !== undefined && newPicture.img_url.length > 0 ? newPicture.img_url : newPictureDefaultPlaceholder"/> <br />
                        <InputText v-model="newPicture.img_url" placeholder="New Image Url" class="gallery-picture-input" type="text" /> <br />
                        <Textarea v-model="newPicture.description" ref="deneme" class="gallery-picture-input p-mt-1" id="picture_url" rows="3" :autoResize="false" /> <br />
                        <Button @click="addNewImage()" icon="pi pi-check" class="p-button-rounded p-button-outlined p-button-info p-mt-1" />
                    </div>
                    <div class="p-ml-1 p-mr-1" v-for="(item, index) in newsForm.pictures" :key="item.id">
                        <Image :src="item.img_url" :alt="item.description" imageClass="gallery-picture p-d-inline" preview /> <br />
                        <InputText v-model="item.img_url" placeholder="Image Url" class="gallery-picture-input" type="text" /> <br />
                        <Textarea v-model="item.description" ref="deneme" class="gallery-picture-input p-mt-1" id="picture_url" rows="3" :autoResize="false" /> <br />
                        <Button @click="removeImage($event, index)" icon="pi pi-trash" class="p-button-rounded p-button-plain p-button-text p-mt-1" />
                    </div>
                </div>
                <div class="p-fluid p-formgrid p-grid p-text-left p-pt-4" style="display:none">
                    <div class="p-field p-col-12 p-md-6">
                        <label for="event">Event Selection</label>
                        <p class="p-text-center p-text-light p-text-italic">
                            `Matching event to a news` feature will be added after first release.
                        </p>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="gallery">Gallery Selection</label>
                        <p class="p-text-center p-text-light p-text-italic">
                            `Matching gallery to a news` feature will be added after first release.
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <div class="p-grid" style="width:100%;">
                <div class="p-col-3 p-text-left">
                    <Button 
                        label="Reset"
                        v-show="newsForm.mode === 'edit'"
                        @click="resetForm()"
                        class="p-button-text" />
                </div>

                <div class="p-col-6 p-text-center">
                    <Button 
                        :label="newsForm.mode === 'edit' ? 'Save changes' : 'Add news'"
                        @click="saveNews()"
                        class="p-text-bold p-button-info" />
                </div>

                <div class="p-col-3">
                    <Button 
                        label="Close"
                        @click="this.isNewsFormVisible = !this.isNewsFormVisible"
                        class="p-button-text p-button-info" />
                </div>
            </div>
        </template>
    </Dialog>
    <!-- </transition> -->

    <!-- news list -->
    <div class="p-grid p-mx-auto">
        <div class="p-col-12 p-md-10 p-mx-auto">
            <Paginator 
                :rows="news.itemPerPage"
                :rowsPerPageOptions="news.itemsPerPageOptions"
                :totalRecords="news.totalCount"
                :first="news.firstItemIndex"
                v-show="showCreateButton && !news.isLoading"
                @page="onPage($event)" />

            <ProgressBar mode="indeterminate" v-show="news.isLoading" style="height: .2em" />

            <div v-show="!news.isLoading">
                <div v-for="(newsObject, index) in news.items"
                    :key="newsObject.id"
                    class="p-grid p-jc-center box p-mt-2"
                    :class="[
                        (isSilenced(newsObject) ? 'silenced-news ':''),
                        (isRecentlyAdded(newsObject) ? 'recently-added-news' : ''),
                        (isDetailsFailed(newsObject) ? 'details-failed-added-news' : '')
                    ]"
                    :data-silenced_words="newsObject.silenced && newsObject.silenced_matches !== null && newsObject.silenced_matches !== undefined ?
                        (newsObject.silenced_matches.map(match => match.word)).join(',') : null"
                    >
                    <div class="p-col-12 p-md-3">
                        <a :href="newsObject.img_url">
                            <img class="p-mt-2" :src="newsObject.img_url" style="max-width:90%;" />
                        </a>
                        <div class="p-text-left" v-if="newsObject.date !== undefined && newsObject.date !== null">
                            <span class="p-text-bold" style="font-size: 0.9rem;">
                                #{{newsObject.id}}
                            </span>
                            <p class="news-details-date-value" style="color:lightgray">
                                Haber: <span class="p-text-bold" style="float:right">{{newsObject.news_date}}</span>
                            </p>
                            <!-- bu alanla hiç ilgilenmediğimiz için kapattım. -->
                            <p class="news-details-date-value" style="color:gray; display:none;"> 
                                <span v-if="newsObject.last_updated_date !== undefined && newsObject.last_updated_date !== null
                                    && newsObject.last_updated_date !== newsObject.date">
                                    Güncelleme: <span style="float:right">{{newsObject.last_updated_date}}</span>
                                </span>
                                <span v-else>
                                    Eklenme: <span style="float:right">{{newsObject.date}}</span>
                                </span>
                            </p>
                            <p class="news-details-date-value" style="color:gray">
                                <!-- bu alanla hiç ilgilenmediğimiz için kapattım. -->
                                <span style="display:none" v-if="newsObject.news_details_saved_date !== undefined && newsObject.news_details_saved_date !== null">
                                    Detay: <span style="float:right">{{newsObject.news_details_saved_date}}</span>
                                </span>
                                <span v-if="newsObject.source !== undefined && newsObject.source !== null">
                                    Kaynak: <span class="p-text-bold" style="float:right;">{{newsObject.source.toUpperCase()}}</span>
                                    
                                    <p v-if="newsObject.is_news_collector">
                                        Added by News Collector
                                    </p>
                                </span>
                            </p>
                        </div>
                        <p class="p-text-left p-text-bold" style="color:#ffc700"
                            v-show="(newsObject.teams !== null && newsObject.teams !== undefined && newsObject.teams.length > 0)">
                            {{newsObject.teams}}
                        </p>
                        <p class="p-text-left" style="color:#ff9900"
                            v-show="(newsObject.ss_event_id !== null && newsObject.ss_event_id !== undefined && newsObject.ss_event_info !== null)">
                            {{newsObject.ss_event_info}}
                        </p>
                        <div v-if="newsObject.event_image !== undefined && newsObject.event_image !== null">
                            <div style="position: relative;">
                                <img class="event-image-home-logo" :src="this.getEventImageTeamLogoSrc(newsObject.event_image.h)" />
                                <img :src="this.getEventImageSrc(newsObject.event_image)" class="notification-picture" />
                                <img class="event-image-away-logo" :src="this.getEventImageTeamLogoSrc(newsObject.event_image.a)" />
                            </div>
                        </div>
                        <p v-show="newsObject.middle_page_ad_enabled" class="p-text-left" style="font-size: 0.9em;">
                            <img class="icon" src="../assets/admob-icon.png" /> Middle Page Ad Enabled
                        </p>
                        <div class="p-text-left">
                            {{ newsObject.has_pictures ? 'Foto galeri (' + newsObject.pictures?.length + ')' : '' }}
                            <br/>
                            <a :href="newsObject.video_url"
                                target="_blank"
                                v-show="(newsObject.video_url !== null && newsObject.video_url !== undefined && newsObject.video_url.length > 0)">Video haber</a>
                        </div>
                        <div class="p-text-left">
                            <Tag v-show="isSilenced(newsObject)" value="Silenced" severity="info" class="tag-silenced tag" />
                            <Tag v-show="isRecentlyAdded(newsObject)" value="Recently added" severity="info" class="tag-recently-added tag" />
                            <Tag v-show="isDetailsFailed(newsObject)" value="Details failed" severity="danger" class="tag-details-failed tag" />
                        </div>
                        <div class="p-text-left">
                            <Button icon="pi pi-info-circle" class="p-button p-button-info p-button-text"
                                v-show="showCreateButton"
                                @click="popupNewsInfo(newsObject)" />
                        </div>
                        <div v-if="newsObject.is_ai_content_available" class="p-text-left">
                            <Button v-if="newsObject.is_ai_content_in_use && (newsObject.pictures !== undefined && newsObject.pictures !== null && newsObject.pictures.length > 0)"
                                    @click="showGalleryNewsPopup(newsObject, index)" label="AI Content In Use"
                                    class="p-text-bold p-button-sm p-button-raised p-button-help p-mr-1" />
                            <Button v-else-if="newsObject.is_ai_content_in_use" label="AI Content In Use" @click="popupNewsAIContent(newsObject, index)"
                                class="p-text-bold p-button-sm p-button-raised p-button-help p-mr-1" />


                            <Button v-if="newsObject.pictures !== undefined && newsObject.pictures !== null && newsObject.pictures.length > 0"
                                    @click="showGalleryNewsPopup(newsObject, index)" label="AI Content Available"
                                    class="p-button-sm p-button-outlined p-button-help p-ml-1 p-mr-1" />
                            <Button v-else
                                label="AI Content Available" @click="popupNewsAIContent(newsObject, index)"
                                class="p-button-sm p-button-outlined p-button-help p-ml-1 p-mr-1" />
                        </div>
                    </div>
                    <div class="p-col-12 p-md-9 p-text-left p-pl-4">
                        <div id="news_content_container" style="overflow: hidden;">
                            <h2>{{newsObject.title}}</h2>
                            <p class="p-text-bold">
                                {{newsObject.subtitle}}
                            </p>
                            <p class="p-text-light news-content-small"
                                v-html="newsObject.content"
                                id="news_content"
                                :ref="(el) => setNewsContentRef(el, newsObject.id)">
                            </p>
                        </div>
                        <div v-if="newsObject.pictures !== undefined && newsObject.pictures !== null && newsObject.pictures.length > 0">
                            <Galleria ref="galleria" :activeIndex="newsObject.activeIndex" :value="newsObject.pictures" :responsiveOptions="newsThumbnailsResponsiveOptions" :numVisible="5">
                                <template #item="picture">
                                    <img :src="picture.item.img_url" class="news-gallery-preview" />
                                </template>
                                <template #thumbnail="picture">
                                    <img :src="picture.item.img_url" class="news-gallery-thumbnail" />
                                </template>
                            </Galleria>
                        </div>
                        <div class="p-mt-4 p-grid">
                            <div class="p-col-12 p-md-6 p-text-left">
                                <Button label="Read more" icon="pi pi-angle-down"
                                    class="p-button-text p-button-info"
                                    v-show="isDetailsReady(newsObject) && newsObject.content !== null && newsObject.content !== undefined && newsObject.content.length > 10"
                                    @click="toggleNewsHeight($event, newsObject.id)" />
                            </div>
                            <div class="p-col-12 p-md-6 p-text-right">
                                <Button label="Options" aria-haspopup="true" aria-controls="overlay_menu"
                                    class="p-button-text p-button-info" icon="pi pi-ellipsis-v"
                                    @click="toggleOptions($event, selectedNewsSource, newsObject, index)"  />
                                <Menu id="overlay_menu" :ref="(el) => setMenuRef(el, index)" :model="newsOptionsMenu.items" :popup="true" />
                            </div>
                        </div>
                    </div>
                    <div class="p-offset-3 p-col-9 p-md-9 p-text-center p-pl-4">
                        <p v-show="newsObject.reactions !== undefined && newsObject.reactions !== null" class="p-text-left" style="font-size: 0.9em;">
                            <span v-for="(reaction, reactionIndex) in newsObject.reactions" :key="reactionIndex">
                                <div style="text-align:center; width: 100px; float: left; margin-left: 20px">
                                    <img class="icon" :src="`images/reaction/${reaction.code}.png`" />
                                    <p>
                                        <Slider disabled v-model="reaction.counter" :max="newsObject.total_reaction" />
                                        <br/>
                                        {{reaction.counter}}
                                    </p>
                                </div>
                            </span>
                        </p>
                    </div>
                </div>
            </div>
            
            <ProgressBar mode="indeterminate" v-show="news.isLoading" style="height: .2em" />

            <Paginator 
                :rows="news.itemPerPage"
                :rowsPerPageOptions="news.itemsPerPageOptions"
                :totalRecords="news.totalCount"
                :first="news.firstItemIndex"
                v-show="showCreateButton && !news.isLoading"
                @page="onPage($event)" />
        </div>
    </div>

    <Divider align="center" class="p-mt-6">
        <div class="p-d-inline-flex p-ai-center">
        <b>About</b>
        </div>
    </Divider>

    <div class="p-col-12 p-md-9 p-mx-auto p-mt-2 p-text-left">
        <div class="p-d-flex">
        <i class="fa fa-info p-mr-3"></i> Uygulama genelindeki haber yönetimi buradan sağlanır.
        <br/> Haber eklerken takım seçimi (max 2 takım) yapılabilir. Seçilen takımların haberlerinde listelenir.
        <br/> Habere foto galeri eklenebilir. Fotoğrafların altına opsiyonel açıklama eklenebilir.
        <br/> Haber eklenirken bildirim de oluşturulabilir. Takım seçildiyse bildirim kategorilerine bu takımlar otomatik olarak eklenir.
        <br/> Listelenen haber kaynaklarından haberler listelenir, hızlı şekilde ekleyebilmek için haber detayları forma yüklenir.
        <br/> Haber detayı getirilirken ayrıca bir servis çağrısı yapılır, haberin detayı getirilir. Foto galeri içeriğiyse bu fotoğraflar da galeri alanına yüklenir.
        </div>
    </div>

    <!-- keyword update modal -->
    <Dialog v-model:visible="popupNewsObject.visible"
        header="News info"
        :modal="true" class="p-fluid p-col-6">
        <TabView class="p-pt-3">
            <TabPanel header="Weight results">
                <div class="p-grid">
                    <json-viewer
                        v-if="popupNewsObject.item.weight_results_json !== undefined && popupNewsObject.item.weight_results_json !== null"
                        :value="popupNewsObject.item.weight_results_json"
                        :expand-depth="3"
                        theme="json-viewer-theme"
                        :copyable="{ copyText: 'Copy', copiedText: 'Copied', timeout: 3000 }"
                        expanded />
                    <span v-else>
                        Weight result is not available for this news.
                    </span>
                </div>
            </TabPanel>
        </TabView>
    </Dialog>

    <!-- news ai content modal -->
    <Dialog v-model:visible="popupNewsObjectAiContent.visible"
        header="News AI Content"
        :modal="true" class="p-fluid p-col-9">
        <div class="p-grid p-mx-auto" style="line-height: 1.2">
            <div class="p-col-12 p-md-6" v-bind:class="{ 'content-in-use' : popupNewsObjectAiContent.item.is_ai_content_in_use !== true}">
                <h3>Original Content</h3>
                <h4>{{popupNewsObjectAiContent.item.original_subtitle}}</h4>
                <p v-html="popupNewsObjectAiContent.item.original_content"></p>
            </div>
            <div class="p-col-12 p-md-6" v-bind:class="{ 'content-in-use' : popupNewsObjectAiContent.item.is_ai_content_in_use === true}">
                <h3>AI Re-written Content</h3>
                <h4 v-html="popupNewsObjectAiContent.itemDiff.ai_subtitle"></h4>
                <p v-html="popupNewsObjectAiContent.itemDiff.ai_content"></p>
            </div>
        </div>
        <template #footer>
            <div class="p-grid p-mt-2 p-text-center">
                <div class="p-col-6 p-md-6">
                    <Button v-if="popupNewsObjectAiContent.item.is_ai_content_in_use === true"
                        label="Switch to Original" @click="toggleAIContentInUse(popupNewsObjectAiContent.item, popupNewsObjectAiContent.index, 'original')" />
                </div>
                <div class="p-col-6 p-md-6">
                    <Button v-if="popupNewsObjectAiContent.item.is_ai_content_in_use !== true"
                        label="Switch to AI Content" @click="toggleAIContentInUse(popupNewsObjectAiContent.item, popupNewsObjectAiContent.index, 'ai')" />
                </div>
            </div>
        </template>
    </Dialog>

    <!-- gallery news ai content modal -->
    <Dialog v-model:visible="popupGalleryNewsAiContent.visible"
        header="Gallery News AI Content"
        :modal="true" class="p-col-9">
        <div class="p-grid p-mx-auto">
            <div class="p-md-4"></div>
            <div class="p-md-4">
                <h3>Original Content</h3>
            </div>
            <div class="p-md-4">
                <h3>AI Rewritten Content</h3>
            </div>
        </div>
        <div class="p-grid p-mx-auto" style="line-height: 1.2" v-for="(item, index) in popupGalleryNewsAiContent.item.pictures" :key="index">
            <div class="p-col-12 p-md-4">
                <Image imageClass="notification-picture p-d-inline" style="width:100% !important;" preview :src="item.img_url" />
            </div>
            <div class="p-col-12 p-md-4">
                <p v-html="item.original_description"></p>
            </div>
            <div class="p-col-12 p-md-4">
                <p v-html="item.itemDiff"></p>
            </div>
        </div>
        <template #footer>
            <div class="p-grid p-mt-2 p-text-center">
                <div class="p-col-6 p-md-6">
                    <Button v-if="popupGalleryNewsAiContent.item.is_ai_content_in_use === true"
                        label="Switch to Original" @click="toggleAIContentInUse(popupGalleryNewsAiContent.item, popupGalleryNewsAiContent.index, 'original')" />
                </div>
                <div class="p-col-6 p-md-6">
                    <Button v-if="popupGalleryNewsAiContent.item.is_ai_content_in_use !== true"
                        label="Switch to AI Content" @click="toggleAIContentInUse(popupGalleryNewsAiContent.item, popupGalleryNewsAiContent.index, 'ai')" />
                </div>
            </div>
        </template>
    </Dialog>

    <!-- event selection dialog -->
    <Dialog modal maximizable v-model:visible="popupEventSelection.visible" class="p-col-12 p-md-9 p-mx-auto"
        :header="'Select Event ' + dateToYMD(popupEventSelection.date)">
        <div class="p-grid">
            <div class="p-col-6 p-md-6 p-mx-auto">
                <Listbox v-model="popupEventSelection.selectedCategory"
                    :options="popupEventSelection.categories"
                    optionLabel="category.name"
                    @change="popupEventCategoryChanged()"
                    listStyle="max-height:500px" style="width:100%" />
            </div>
            <div class="p-col-6 p-md-6 p-mx-auto" 
                :visible="popupEventSelection.events !== undefined && popupEventSelection.events !== null">
                <Listbox v-model="popupEventSelection.selectedEvent"
                    :options="popupEventSelection.events"
                    :filter="true"
                    optionLabel="event_info"
                    listStyle="max-height:500px" style="width:100%" />
            </div>
        </div>
        <template #footer>
            <div class="p-grid p-mt-2">
                <div class="p-col-3 p-md-1">
                    <Button label="Clear" 
                        class="p-button-text p-button-danger"
                        @click="popupEventClearSelection()" />
                </div>
                <div class="field p-col-6 p-md-10 p-text-center">
                    <label for="dateformat"></label>
                    <Calendar inputId="dateformat"
                        v-model="popupEventSelection.date"
                        dateFormat="yy-mm-dd"
                        @date-select="popupSelectEvent()" />
                </div>
                <div class="p-col-3 p-md-1">
                    <Button label="Save" @click="popupEventSave()" />
                </div>
            </div>
        </template>
    </Dialog>

</template>

<style>
.content-in-use {
    border: 1px solid #c509bc;
    border-radius: 10px;
}

.added-by-ai {
    /* color: #007c48; */
    padding-left: 1px;
    padding-right: 1px;
    background-color: #0f552c;
}

.removed-by-ai {
    /* color: #dc931d94; */
    padding-left: 1px;
    padding-right: 1px;
    background-color: #91332a61;
}

.normal-text {
    color: #FFF;
}

.event-image-home-logo {
    width: 25px; height: 25px;
    position: absolute; left: 0px; top: 30px;
}

.event-image-away-logo {
    width: 25px; height: 25px;
    position: absolute; right: 0px; top: 30px;
}

.notification-picture {
    float: left;
    width: 100%;
    height: 100px;
    object-fit: contain;
    text-align: center;
    border-radius: 4px;
}

.p-slider-handle {
    display: none !important;
}

.news-details-date-value {
    margin: 0px;
    padding: 0px;
}

.news-gallery-thumbnail {
    max-width: 120px;
    max-height: 120px;
}

.news-gallery-preview {
    max-width: 480px;
    max-height: 480px;
}

.show-item {
    display: block;
}
.hide-item {
    display: none;
}

.recently-added-news {
    background-color: #00660033 !important;
    opacity: 0.8;
}

.details-failed-added-news {
    background-color: #b1000044 !important;
    opacity: 0.8;
}

.disabled-news {
    background-color: #666666BB !important;
    opacity: 0.8;
}

.silenced-news {
    background-color: #444444BB !important;
    opacity: 0.5;
}

.silenced-news::before {
    font-weight: bold;
    color:coral;
    font-size:1.5rem;
    content: '\01F515\0020 Silenced: ' attr(data-silenced_words) ' \01F515';
    position: absolute;
}

.news-content-small {
    max-height: 100px;
}

.news-content-full {
    max-height: 100%;
}

.news-gallery::-webkit-scrollbar {
    width: 12px;                /* width of the entire scrollbar */
    height: 12px;               /* height of the entire scrollbar */
}

.news-gallery::-webkit-scrollbar-track {
    background: #29323d;        /* color of the tracking area */
}

.news-gallery::-webkit-scrollbar-thumb {
    background-color: #9bd1db;    /* color of the scroll thumb */
    border-radius: 20px;       /* roundness of the scroll thumb */
    border: 3px solid #29323d;  /* creates padding around scroll thumb */
}

.notification-picture {
    float: left;
    width: 100%;
    height: 100px;
    object-fit: contain;
    text-align: center;

    border-radius: 4px;
}

.gallery-picture {
    float: left;
    width: 175px;
    height: 150px;
    object-fit: contain;
    text-align: center;

    border-radius: 4px;
}
.gallery-picture-input {
    width: 175px;
}

.expand-enter-active,
.expand-leave-active {
    transition: max-height .5s ease-in;
    max-height: 1000px;
}

.expand-enter,
.expand-leave-to {
    transition-timing-function: ease-out;
    max-height: 0;
    overflow: hidden;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}

.icon {
  max-width: 24px; max-height:24px;
}

.icon-mini {
  max-width: 18px; max-height:18px;
}
</style>

<style lang="scss" scoped>
@media screen and (max-width: 489px) {
    .p-formgroup-inline {
        .p-field {
            margin-bottom: 1em !important;
        }
    }
}

.layout-content .content-section.implementation > h3 {
    font-weight: 600;
}

textarea {
    resize: none;
}

.card {
    background: var(--surface-e);
    padding: 2rem;
    -webkit-box-shadow: 0 2px 1px -1px rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 1px 3px 0 rgb(0 0 0 / 12%);
    box-shadow: 0 2px 1px -1px rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 1px 3px 0 rgb(0 0 0 / 12%);
    border-radius: 4px;
    margin-bottom: 2rem;
}
</style>

<script>
import axios from "axios";

import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Textarea from 'primevue/textarea'
import AutoComplete from 'primevue/autocomplete'
import Paginator from 'primevue/paginator'
import ProgressBar from 'primevue/progressbar'
import Image from 'primevue/image'
import MultiSelect from 'primevue/multiselect'
import Divider from 'primevue/divider'
import Galleria from 'primevue/galleria'
import Tag from 'primevue/tag'
import Menu from 'primevue/menu'
import Dialog from 'primevue/dialog'
import TabView from 'primevue/tabview'
import TabPanel from 'primevue/tabpanel'
import Listbox from 'primevue/listbox'
import Calendar from 'primevue/calendar'
import Checkbox from 'primevue/checkbox'
import Slider from 'primevue/slider'
import Dropdown from 'primevue/dropdown'

import dayjs from 'dayjs'

import { isEmpty } from '../utils/utils'
import Const from '../utils/const'
import { diffWords } from 'diff'

let SpringApi;

export default {
    name: 'NewsManagement',
    components: {
        Button, InputText, Textarea, AutoComplete, Paginator, ProgressBar, Image, MultiSelect, Divider, Galleria, Tag, Menu,
        Dialog, TabView, TabPanel, Listbox, Calendar, Checkbox, Slider, Dropdown
    },
    data() {
        return {
            selectedNewsSource: Const.NewsSource.SLC,
            isNewsFormVisible: false,
            teams: [],
            selectedTeams: [],
			filteredTeams: [],
            newsForm: { source: Const.NewsSource.SLC, pictures: [] },
            newPicture: {},
            newPictureDefaultPlaceholder: 'images/placeholder.png',
            news: {
                items: [],
                currentPage: 1,
                totalCount: undefined,
                itemPerPage: undefined,
                itemsPerPageOptions: [5, 10, 20, 30, 50],
                isLoading: false,
                firstItemIndex: undefined,
                newsIndex: -1
            },
            newsSources: [
                { id: Const.NewsSource.SLC, name: 'Haberler' },
                { id: Const.NewsSource.NTVSpor, name: 'NTVSpor' },
                { id: Const.NewsSource.SporX, name: 'SporX' },
                { id: Const.NewsSource.Fanatik, name: 'Fanatik' },
                { id: Const.NewsSource.Fotomac, name: 'Fotomaç' },
                { id: Const.NewsSource.Mynet, name: 'Mynet' },
                { id: Const.NewsSource.Mackolik, name: 'Maçkolik' },
                { id: Const.NewsSource.Beinsports, name: 'Beinsports' }
                // "slc", "ntvspor", "sporx", "fanatik", "fotomac", "mynet", "mackolik", "beinsports"
            ],
            newsSourcesSubCategories: [],
            isPictureGalleryFormVisible: false,
            isCreateNotificationFormVisible: false,
            newsNotification: {},
            notificationCategories: [],
            newsSelectedNotificationCategories: [],
            newsThumbnailsResponsiveOptions: [{
                    breakpoint: '1024px',
                    numVisible: 5
                },{
                    breakpoint: '768px',
                    numVisible: 3
                },{
                    breakpoint: '560px',
                    numVisible: 1
            }],
            newsOptionsMenu: {
                newsObject: null,
                selectedNewsSource: null,
                index: null,
                items: null
            },
            popupNewsObject: {
                visible: false,
                item: null
            },
            popupNewsObjectAiContent: {
                visible: false,
                item: null,
                itemDiff: {
                    ai_subtitle: null,
                    ai_content: null,
                }
            },
            popupGalleryNewsAiContent: {
                visible: false,
                item: null,
                itemDiff: {
                    ai_description: null
                }
            },
            popupEventSelection: {
                visible: false,
                date: new Date(),
                categories: null,
                selectedCategory: null,
                events: null,
                selectedEvent: null
            },
            newsEventImage: {
                items: this.getEventImagesList(),
                selected: {
                    background_url: null
                }
            },
            newsContentRefs: {},
            menuRefs: {},
        }
    },
    emits: ["loginResult", "pageLoaded"],
    beforeMount() {
        this.$emit('pageLoaded', {
            title: 'News Management'
        })

        SpringApi = axios.create({
            baseURL : process.env.VUE_APP_SPRING_API_URL,
            headers: {
                'Authorization': 'Bearer ' + this.$cookies.get('token')
            }
        });
    },
    mounted() {
        let self = this
        let urlSource = self.$route.query.source

        var newsSourceFound = false
        for (let k in self.newsSources) {
            if (self.newsSources[k].id === urlSource) {
                newsSourceFound = true;
                break;
            }
        }
        
        self.selectedNewsSource = (!isEmpty(urlSource) && newsSourceFound) ? urlSource : Const.NewsSource.SLC
        self.loadTeams()

        self.getNews(self.selectedNewsSource)
    },
    beforeUpdate() {
        this.newsContentRefs = {};
        this.menuRefs = {};
    },
    methods: {
        newsSourceSelected(event) {
            const newSource = event.currentTarget.getAttribute('value')
            this.selectedNewsSource = newSource
            this.$router.push('/news-management?source='+newSource)

            this.getNews(newSource)
        },
        loadTeams() {
            const self = this,
                cookies = self.$cookies,
                toast = self.$toast,
                token = self.$cookies.get("token");
            
            self.$http.get('api/tournaments/'+Const.TournamentIds.SuperLig+'/teams', {
                headers: {
                    'authorization': 'Bearer ' + token
                }
            })
            .then(function (response) {
                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set("token", response.headers['refresh-token']);
                    const data = response.data

                    data.items.push({
                        id: 0,
                        ss_team_id: 0,
                        name: "Süper Lig Genel",
                    });

                    data.items.forEach(team => {
                        team.value = team.id
                        self.teams.push(team)
                        self.filteredTeams.push(team)
                    })
                } else if(response.data.kod === Const.KOD.oturumSonlandi) {
                    self.$router.push('/login')
                } else {
                    console.log(response)
                    toast.add({severity:'warn', summary: 'Loading teams failed', detail:response.data.mesaj, life: 3000});
                }
            })
            .catch(function (err) {
                toast.add({severity:'error', summary: 'Error', detail:err, life: 3000});
                console.log(err)
            });
        },
        searchTeams(event) {
            if (!event.query.trim().length) {
                this.filteredTeams = [...this.teams]
            } else {
                this.filteredTeams = this.teams.filter((team) => {
                    return team.name.toLowerCase().startsWith(event.query.toLowerCase());
                });
            }
        },
        toggleNewsForm() {
            this.newsForm.middle_page_ad_enabled = false
            this.isNewsFormVisible = !this.isNewsFormVisible
        },
        resetForm() {
            this.selectedNewsSource = Const.NewsSource.SLC
            this.selectedTeams = []
            this.newsForm = { source: Const.NewsSource.SLC }
            this.clearEventImageSelection()
        },
        saveNews() {
            let self = this,
                newsForm = self.newsForm,
                mode = newsForm.mode,
                newsIndex = newsForm.newsIndex
            
            if(mode === 'edit' && !isEmpty(newsForm.newsId) && newsForm.newsId > 0) {
                self.updateNews(newsIndex)
            } else {
                self.addNews()
            }
        },
        addNews() {
            let self = this,
                toast = self.$toast,
                newsForm = self.newsForm,
                newPicture = self.newPicture,
                toastMessage = null,
                cookies = self.$cookies,
                token = self.$cookies.get('token');

            // event_image
            var eventImage = this.getEventImage()

            if(isEmpty(newsForm.img_url)) {
                toastMessage = 'Image url is empty!'
            } else if(isEmpty(newsForm.title)) {
                toastMessage = 'Title is empty!'
            } else if(isEmpty(newsForm.video_url) && isEmpty(newsForm.content) && isEmpty(newsForm.pictures)) {
                toastMessage = 'News content is empty!'
            } else if(newPicture !== null && (!isEmpty(newPicture.img_url) || !isEmpty(newPicture.description))) {
                toastMessage = 'Picture is not added to gallery.'
            } else if (newsForm.event_image_enabled && (eventImage.h === undefined || eventImage.h === null || eventImage.a === undefined || eventImage.a === null)) {
                toastMessage = 'Team Ids are gone. Reselect the event from Event Selection popup.'
            }

            if(isEmpty(toastMessage) && self.isCreateNotificationFormVisible) {
                if(self.newsSelectedNotificationCategories === undefined || self.newsSelectedNotificationCategories === null
                    || self.newsSelectedNotificationCategories.length == 0) {
                    toastMessage = 'Notification categories not selected!'
                } else {
                    var categoryIds = []
                    self.newsSelectedNotificationCategories.forEach(item => categoryIds.push(item.id))
                    
                    newsForm.notification = self.newsNotification
                    newsForm.notification.category_ids = categoryIds
                }
            }

            if(!isEmpty(toastMessage)) {
                toast.add({severity:'warn', summary: 'Something missing!', detail: toastMessage, life: 3000});
                return
            }

            if(self.selectedTeams !== null && self.selectedTeams.length > 0) {
                if(self.selectedTeams[0]) {
                    newsForm.ss_team_id = self.selectedTeams[0].ss_team_id
                }

                if(self.selectedTeams.length > 1 && self.selectedTeams[1]) {
                    newsForm.ss_team_id_2 = self.selectedTeams[1].ss_team_id
                }
            }

            newsForm.event_image = eventImage

            newsForm.ss_event_info = self.popupEventSelection.selectedEvent?.event_info ?? null
            newsForm.ss_event_id = self.popupEventSelection.selectedEvent?.id ?? null

            self.$http.post('api/news', newsForm, {
                headers: {
                    'authorization': 'Bearer ' + token
                }
            })
            .then(function (response) {
                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set("token", response.headers['refresh-token']);

                    self.newsForm = { source: Const.NewsSource.SLC }
                    self.isNewsFormVisible = false

                    // set current source to slc
                    self.$router.push('/news-management?source='+self.selectedNewsSource)
                    self.selectedNewsSource = Const.NewsSource.SLC
                    self.getNews(self.selectedNewsSource)

                    toast.add({severity:'success', summary: 'Success', detail: 'News added successfully.', life: 3000});
                } else {
                    console.log(response.data)
                    toast.add({severity:'warn', summary: 'Adding news failed', detail:response.data.mesaj, life: 3000});
                }
            })
            .catch(function (err) {
                console.log(err)
                toast.add({severity: 'error', summary: 'Error', detail: err});
            });
        },
        async newsSourceSubCategorySelected(newsSubCategoryId, newsSourceId) {
            let self = this,
                toast = self.$toast,
                token = self.$cookies.get('token');
            
            if(self.selectedNewsSource === Const.NewsSource.SLC) {
                self.getNews(Const.NewsSource.SLC, 1, null, newsSourceId)
            } else {
                // get news by sub category
                try {
                    self.news.isLoading = true
    
                    let result = await self.$http.get(`/api/news/source/${newsSourceId}?sub_category_id=${newsSubCategoryId}`, {
                        headers: { 'authorization': 'Bearer ' + token }
                    })
    
                    self.news.items = result.data.items
                } catch(error) {
                    console.log(error)
                    toast.add({severity:'error', summary: 'Error', detail: error, life: 3000});
                } finally {
                    self.news.isLoading = false
                }
            }

        },
        async getNews(newsSourceId, page = 1, limit = null, source = null) {
            let self = this,
                toast = self.$toast,
                cookies = self.$cookies,
                token = self.$cookies.get('token');
            
            if(newsSourceId.toLowerCase() === Const.NewsSource.SLC) {
                self.news.isLoading = true
                self.$http.get(`api/news`, {
                    params: {
                        page: page,
                        limit: limit,
                        source: source
                    },
                    headers: {
                        'authorization': 'Bearer ' + token
                    }
                }).then(function (response) {
                    self.news.isLoading = false
                    let data = response.data
                    if(!isEmpty(data.kod) && data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                        cookies.set("token", response.headers['refresh-token']);
                        
                        self.news.items = data.items
                        self.news.itemPerPage = data.itemPerPage
                        self.news.totalCount = data.totalCount
                        self.news.currentPage = page
                        self.news.firstItemIndex = (self.news.currentPage - 1) * self.news.itemPerPage

                        self.news.items.forEach((item, index) => {
                            self.news.items[index] = self.prepareNewsItem(item)

                            if (self.news.items[index].has_pictures) {
                                self.news.items[index].pictures.forEach((pic, picIndex) => {
                                    self.news.items[index].pictures[picIndex].itemDiff = null;
                                })
                            }
                        })
                    } else if(data.kod === Const.KOD.oturumSonlandi) {
                        self.$router.push('/login')
                    } else {
                        toast.add({severity:'warn', summary: 'Loading news failed', detail:response.data.mesaj, life: 3000});
                    }
                }).catch(function (err) {
                    self.news.isLoading = false
                    console.log(err)
                    toast.add({severity:'error', summary: 'Error', detail:err, life: 3000});
                });

                // sub categories for slc
                self.newsSourcesSubCategories = [{
                    id: 1,
                    title: 'All',
                    source: null
                },{
                    id: 2,
                    title: 'SporX',
                    source: 'sx'
                },{
                    id: 3,
                    title: 'NTVSpor',
                    source: 'ntv'
                }]
            } else {
                self.news.isLoading = true
                self.$http.get('api/news/source/'+newsSourceId.toLowerCase(), {
                    headers: {
                        'authorization': 'Bearer ' + token
                    }
                }).then(function (response) {
                    self.news.isLoading = false
                    self.news.items = response.data.items

                    self.news.items.forEach((item, index) => {
                        if (self.news.items[index].has_pictures) {
                            self.news.items[index].pictures.forEach((pic, picIndex) => {
                                self.news.items[index].pictures[picIndex].itemDiff = null;
                            })
                        }
                    })
                }).catch(function (err) {
                    console.log(err)
                    
                    self.news.isLoading = false
                    toast.add({severity:'error', summary: 'Uppss!', detail: 'Bu haber kaynagi henüz hazir degil: ' + newsSourceId, life: 3000});
                    toast.add({severity:'error', summary: 'Error', detail: err, life: 3000});
                });
            
                // get sub categories if existed
                try {
                    let result = await self.$http.get(`/api/news-sub-categories?source=${newsSourceId}`, {
                        headers: { 'authorization': 'Bearer ' + token }
                    })
    
                    let items = result.data.items
                    
                    self.newsSourcesSubCategories = items
                } catch(error) {
                    console.log(error)
                }
            }
        },
        async editNews(news, newsIndex) {
            let self = this,
                toast = self.$toast,
                token = self.$cookies.get('token');
            let mImgUrl = news.img_url
            let mVideoUrl = news.video_url
            let mTitle = news.title
            let mSubtitle = news.subtitle
            let mContent = news.content
            let mSelectedTeams = news.selectedTeams
            let mNewsId = news.newsId
            let mHasNotification = news.has_notification
            let mPictures = news.pictures
            let mSource = news.source
            let mMiddlePageAdEnabled = news.middle_page_ad_enabled
            let mEventImage = news.event_image

            self.isCreateNotificationFormVisible = false

            self.newsForm = {
                img_url: mImgUrl,
                video_url: mVideoUrl,
                title: mTitle,
                subtitle: !isEmpty(mSubtitle) ? mSubtitle
                    .replaceAll('<br/>', '\n').replaceAll('<br>', '\n')
                    .replaceAll('<p>', '').replaceAll('</p>', '\n') 
                    .replaceAll('<div>', '').replaceAll('</div>', '') 
                    .replaceAll('<h3>', '<b>').replaceAll('</h3>', '</b>') 
                    .replaceAll('<h2>', '<b>').replaceAll('</h2>', '</b>') 
                    .replaceAll('<h1>', '<b>').replaceAll('</h1>', '</b>') 
                    .replaceAll('<span>', '').replaceAll('</span>', '') 
                    .replaceAll('<strong>', '<b>').replaceAll('</strong>', '</b>')
                    .replaceAll('&nbsp;\n', '\n\n').replaceAll('&nbsp;', ' ')
                    .trim() : '',
                content: !isEmpty(mContent) ? mContent
                    .replaceAll('<br/>', '\n').replaceAll('<br>', '\n')
                    .replaceAll('<p>', '').replaceAll('</p>', '\n') 
                    .replaceAll('<div>', '').replaceAll('</div>', '') 
                    .replaceAll('<h3>', '<b>').replaceAll('</h3>', '</b>') 
                    .replaceAll('<h2>', '<b>').replaceAll('</h2>', '</b>') 
                    .replaceAll('<h1>', '<b>').replaceAll('</h1>', '</b>') 
                    .replaceAll('<span>', '').replaceAll('</span>', '') 
                    .replaceAll('<strong>', '<b>').replaceAll('</strong>', '</b>')
                    .replaceAll('&nbsp;\n', '\n\n').replaceAll('&nbsp;', ' ')
                    .trim() : '',
                newsId: mNewsId,
                mode: 'edit',
                source: mSource ?? Const.NewsSource.SLC,
                pictures: mPictures ?? [],
                has_notification: mHasNotification,
                newsIndex: newsIndex,
                updatedNews: news,
                middle_page_ad_enabled: mMiddlePageAdEnabled,
                event_image_enabled: mEventImage !== undefined && mEventImage !== null
            }

            self.popupEventSelection.selectedEvent = {
                event_info: news.ss_event_info ?? null,
                id: news.ss_event_id ?? null
            }

            if(news.has_pictures) {
                if(self.newsForm.pictures !== undefined && self.newsForm.pictures !== null && self.newsForm.pictures.length > 0) {
                    self.isPictureGalleryFormVisible = true
                } else {
                    try {
                        self.news.isLoading = true
    
                        let response = await self.$http.get('api/news/'+mNewsId, {
                            headers: {
                                'authorization': 'Bearer ' + token
                            }
                        })
    
                        self.newsForm.pictures = response.data.item.pictures
                        self.isPictureGalleryFormVisible = self.newsForm.pictures !== undefined && self.newsForm.pictures !== null && self.newsForm.pictures.length > 0
                    } catch(error) {
                        console.log(error)
                        toast.add({severity:'error', summary: 'Error', detail: 'News details couldn\'t fetch.\n' + error, life: 3000});
                    } finally {
                        self.news.isLoading = false
                    }
                }
            }

            // event_image
            this.clearEventImageSelection()
            if (mEventImage !== undefined && mEventImage !== null) {
                this.newsForm.event_image_enabled = true
                this.eventImageEnabledChanged()

                this.newsEventImage.selected = this.getEventImageObject(mEventImage)

                self.popupEventSelection.selectedEvent.homeTeam = { id: mEventImage.h }
                self.popupEventSelection.selectedEvent.awayTeam = { id: mEventImage.a }
            }

            self.selectedTeams = mSelectedTeams
            self.isNewsFormVisible = true
        },
        updateNews(newsIndex) {
            let self = this,
                news = self.news,
                newsForm = self.newsForm,
                selectedTeams = self.selectedTeams,
                newsId = newsForm.newsId,
                newPicture = self.newPicture,
                toast = self.$toast,
                toastMessage = null,
                cookies = self.$cookies,
                token = cookies.get('token');

            // event_image
            var eventImage = this.getEventImage()

            if(isEmpty(newsForm.img_url)) {
                toastMessage = 'Image url is empty!'
            } else if(isEmpty(newsForm.title)) {
                toastMessage = 'Title is empty!'
            } else if(isEmpty(newsForm.content) && isEmpty(newsForm.video_url) && isEmpty(newsForm.pictures)) {
                toastMessage = 'News content is empty!'
            } else if(newPicture !== null && (!isEmpty(newPicture.img_url) || !isEmpty(newPicture.description))) {
                toastMessage = 'Picture is not added to gallery.'
            } else if (newsForm.event_image_enabled && (eventImage.h === undefined || eventImage.h === null || eventImage.a === undefined || eventImage.a === null)) {
                toastMessage = 'Team Ids are gone. Reselect the event from Event Selection popup.'
            }

            if(isEmpty(toastMessage) && self.isCreateNotificationFormVisible) {
                if(self.newsSelectedNotificationCategories === undefined || self.newsSelectedNotificationCategories === null
                    || self.newsSelectedNotificationCategories.length == 0) {
                    toastMessage = 'Notification categories not selected!'
                } else {
                    var categoryIds = []
                    self.newsSelectedNotificationCategories.forEach(item => categoryIds.push(item.id))
                    
                    newsForm.notification = self.newsNotification
                    newsForm.notification.category_ids = categoryIds
                }
            }

            if(!isEmpty(toastMessage)) {
                toast.add({severity:'warn', summary: 'Something missing!', detail: toastMessage, life: 3000});
                return
            }

            if(self.selectedTeams !== null && self.selectedTeams.length > 0) {
                if(self.selectedTeams[0]) {
                    newsForm.ss_team_id = self.selectedTeams[0].ss_team_id
                }

                if(self.selectedTeams.length > 1 && self.selectedTeams[1]) {
                    newsForm.ss_team_id_2 = self.selectedTeams[1].ss_team_id
                }
            }

            newsForm.event_image = eventImage

            newsForm.subtitle = newsForm.subtitle.replaceAll('\n', '<br/>')
            newsForm.content = newsForm.content.replaceAll('\n', '<br/>')

            newsForm.ss_event_info = self.popupEventSelection.selectedEvent?.event_info ?? null
            newsForm.ss_event_id = self.popupEventSelection.selectedEvent?.id ?? null

            self.$http.put('api/news/'+newsId, newsForm, {
                headers: {
                    'authorization': 'Bearer ' + token
                }
            })
            .then(function (response) {
                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set("token", response.headers['refresh-token']);

                    self.newsForm = { source: Const.NewsSource.SLC }
                    self.isNewsFormVisible = false

                    // set current source to slc
                    // self.$router.push('/news-management?source='+self.selectedNewsSource)
                    // self.selectedNewsSource = Const.NewsSource.SLC
                    // self.getNews(self.selectedNewsSource)

                    news.items[newsIndex].title = newsForm.title
                    news.items[newsIndex].subtitle = newsForm.subtitle
                    news.items[newsIndex].img_url = newsForm.img_url
                    news.items[newsIndex].video_url = newsForm.video_url
                    news.items[newsIndex].content = newsForm.content
                    news.items[newsIndex].pictures = newsForm.pictures
                    news.items[newsIndex].has_notification = newsForm.notification !== undefined && newsForm.notification !== null
                    news.items[newsIndex].ss_event_id = newsForm.ss_event_id
                    news.items[newsIndex].ss_event_info = newsForm.ss_event_info
                    news.items[newsIndex].ss_team_id = newsForm.ss_team_id
                    news.items[newsIndex].ss_team_id_2 = newsForm.ss_team_id_2
                    news.items[newsIndex].middle_page_ad_enabled = newsForm.middle_page_ad_enabled
                    news.items[newsIndex].event_image = newsForm.event_image

                    var teams = ""
                    if (selectedTeams !== null && selectedTeams.length > 0) {
                        news.items[newsIndex].team1 = selectedTeams[0].name
                        teams += selectedTeams[0].name

                        if(selectedTeams.length > 1) {
                            news.items[newsIndex].team2 = selectedTeams[1].name
                            teams += ", " + selectedTeams[1].name
                        } else {
                            news.items[newsIndex].team2 = null
                        }
                    } else {
                        news.items[newsIndex].team1 = null
                        news.items[newsIndex].team2 = null
                    }
                    news.items[newsIndex].selectedTeams = selectedTeams
                    news.items[newsIndex].teams = teams

                    self.clearEventImageSelection()
                    toast.add({severity:'success', summary: 'Success', detail: 'News updated successfully.', life: 3000});
                } else {
                    toast.add({severity:'warn', summary: 'Update news failed', detail:response.data.mesaj, life: 3000});
                }
            })
            .catch(function (err) {
                console.log(err)
                toast.add({severity: 'error', summary: 'Error', detail: err});
            });
        },
        deleteNews(newsId) {
            let self = this,
                toast = self.$toast,
                cookies = self.$cookies,
                token = self.$cookies.get('token');
            
            this.$confirm.require({
                message: 'Are you sure you want to delete this news?',
                header: 'Delete',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: 'Delete',
                rejectLabel: 'Cancel',
                accept: () => {
                    self.$http.delete('api/news/'+newsId, {
                        headers: {
                            'authorization': 'Bearer ' + token
                        }
                    })
                    .then(function (response) {
                        if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                            cookies.set("token", response.headers['refresh-token']);

                            self.newsForm = { source: Const.NewsSource.SLC }
                            self.isNewsFormVisible = false

                            // set current source to slc
                            self.$router.push('/news-management?source='+self.selectedNewsSource)
                            self.selectedNewsSource = Const.NewsSource.SLC
                            self.getNews(self.selectedNewsSource)

                            toast.add({severity:'success', summary: 'Success', detail: 'News deleted successfully.', life: 3000});
                        } else {
                            toast.add({severity:'warn', summary: 'Deleting news failed', detail:response.data.mesaj, life: 3000});
                        }
                    })
                    .catch(function (err) {
                        console.log(err)
                        toast.add({severity: 'error', summary: 'Error', detail: err});
                    });
                },
                reject: () => {
                }
            });
        },
        onPage(event) {
            this.$router.push(`/news-management?source=${this.selectedNewsSource}`)

            this.getNews(this.selectedNewsSource, event.page + 1, event.rows)
        },
        getNewsDetailsForInsert(selectedNewsSource, news) {
            let self = this,
                newsId = news.id,
                galleryId = news.gallery_id,
                videoId = 0,
                contentType = news.content_type,
                toast = self.$toast,
                cookies = self.$cookies,
                token = cookies.get('token');

            if(selectedNewsSource === Const.NewsSource.NTVSpor) {
                if(!isEmpty(contentType) && contentType === "foto") {
                    videoId = 0;
                    galleryId = newsId;
                } else if(!isEmpty(contentType) && contentType === "video") {
                    videoId = newsId;
                    galleryId = 0;
                }
            }

            self.$http.get('api/news/source/'+selectedNewsSource.toLowerCase()+'/news/'+newsId+'?gallery_id='+galleryId+'&video_id='+videoId, {
                headers: {
                    'authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set("token", response.headers['refresh-token']);

                    let newsDetails = response.data.item

                    newsDetails.img_url = news.img_url
                    newsDetails.title = news.title
                    newsDetails.subtitle = news.subtitle

                    self.newsForm = newsDetails
                    self.newsForm.mode = 'add'
                    self.newsForm.source = selectedNewsSource
                    self.newsForm.news_id = ''+newsId+''
                    self.isNewsFormVisible = true

                    self.isPictureGalleryFormVisible = self.newsForm.pictures !== undefined && self.newsForm.pictures !== null && self.newsForm.pictures.length > 0

                    window.scrollTo({top: 0, behavior: 'smooth'});
                } else {
                    toast.add({severity:'warn', summary: 'Update news failed', detail: response.data.mesaj, life: 3000});
                }
            }).catch(function (err) {
                console.log(err)
                toast.add({severity: 'error', summary: 'Error', detail: err});
            })

        },
        insertPhotoGallery() {
            this.isPictureGalleryFormVisible = !this.isPictureGalleryFormVisible
        },
        addNewImage() {
            let self = this,
                toast = self.$toast,
                newPicture = self.newPicture,
                newsForm = self.newsForm

            if(newPicture === null || newPicture.img_url === null || newPicture.img_url === undefined || newPicture.img_url.length === 0) {
                toast.add({severity:'warn', summary: 'Uppss!', detail: 'Image URL is empty.', life: 3000});
                return;
            }

            if(newsForm.pictures === null || newsForm.pictures === undefined) {
                newsForm.pictures = []
            }

            newsForm.pictures.push({id: -1, img_url: newPicture.img_url, description: newPicture.description})
            newPicture.img_url = ""
            newPicture.description = ""
        },
        removeImage(event, index) {
            let self = this

            this.$confirm.require({
                target: event.currentTarget,
                message: 'Remove this image from gallery?',
                icon: 'pi pi-exclamation-triangle',
                header: 'Delete',
                acceptLabel: 'Delete',
                rejectLabel: 'Cancel',
                accept: () => {
                    self.newsForm.pictures.splice(index, 1)
                },
                reject: () => {
                }
            })
        },
        setNewsContentRef(element, newsId) {
            if (element) {
                this.newsContentRefs[newsId] = element;
            }
        },
        toggleNewsHeight(event, newsId) {
            let button = event.target,
                content = this.newsContentRefs[newsId];

            if (content) {
                if(content.classList.contains('news-content-small')) {
                    content.classList.remove('news-content-small')
                    content.classList.add('news-content-full')
                    button.innerText = 'Read less'
                } else {
                    content.classList.add('news-content-small')
                    content.classList.remove('news-content-full')
                    button.innerText = 'Read more'
                }
            } else {
                console.error(`Content ref for newsId ${newsId} not found!`);
            }
        },
        toggleNotificationForm() {
            let self = this

            if(self.notificationCategories !== null && self.notificationCategories.length > 0) {
                self.newsNotification.title = self.newsForm.title
                self.newsNotification.subtitle = self.newsForm.subtitle
                self.newsNotification.img_url = self.newsForm.img_url

                self.isCreateNotificationFormVisible = !self.isCreateNotificationFormVisible

                if(self.isCreateNotificationFormVisible) {
                    // haber icin takim secimi varsa bildirim kategorisine otomatik ekle
                    self.newsSelectedNotificationCategories = []
                    if(self.selectedTeams !== undefined && self.selectedTeams !== null && self.selectedTeams.length > 0) {
                        self.notificationCategories.forEach(category => {
                            self.selectedTeams.forEach(selectedTeam => {
                                if(category.topic === ''+selectedTeam.ss_team_id+'') {
                                    self.newsSelectedNotificationCategories.push(category)
                                }
                            })
                        })
                    }
                }
            } else {
                self.loadNotificationCategories()
            }
        },
        loadNotificationCategories() {
            let self = this,
                cookies = self.$cookies,
                toast = self.$toast,
                token = cookies.get('token');

            self.$http.get('api/notification-categories', {
                headers: {
                    'authorization': 'Bearer ' + token
                }
            })
            .then(function (response) {
                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    cookies.set('token', response.headers['refresh-token']);
                    let data = response.data

                    self.notificationCategories = data.items

                    // kategoriler yüklendi, bildirim formunu göster
                    self.toggleNotificationForm()
                } else if(response.data.kod === Const.KOD.oturumSonlandi) {
                    self.$router.push('/login')
                } else {
                    toast.add({severity:'warn', summary: 'Loading notification categories failed', detail:response.data.mesaj, life: 3000});
                }
            })
            .catch(function (err) {
                toast.add({severity:'error', summary: 'Error', detail:err});
                console.log(err)
            });
        },
        async updateNewsDetailsByNewsSource(newsId, index) {
            let self = this,
                toast = self.$toast,
                token = self.$cookies.get('token');
            
            try {
                self.news.items[index].isLoading = true

                let response = await self.$http.post(`api/news/${newsId}/force-update`, null, {
                    headers: {
                        'authorization': 'Bearer ' + token
                    }
                })

                if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                    self.$cookies.set("token", response.headers['refresh-token']);

                    let newsItem = response.data.item
                    self.news.items[index] = self.prepareNewsItem(newsItem)

                    toast.add({severity:'success', summary: 'Success', detail: 'News updated successfully.', life: 1500});
                } else {
                    console.log(response.data)
                    toast.add({severity:'warn', summary: 'Updating news failed', detail:response.data.mesaj, life: 3000});
                }
            } catch(error) {
                console.log(error)
                toast.add({severity:'error', summary: 'Error', detail: 'News details couldn\'t updated.\n' + error, life: 3000});
            } finally {
                self.news.items[index].isLoading = false
            }
        },
        prepareNewsItem(news) {
            let item = news
            item.date = dayjs(item.log_date).format('DD/MM/YYYY HH:mm:ss');
                            
            if(item.last_updated_date !== undefined && item.last_updated_date !== null) {
                item.last_updated_date = dayjs(new Date(item.last_updated_date)).format('DD/MM/YYYY HH:mm:ss');
            }

            if(item.news_details_saved_date !== undefined && item.news_details_saved_date !== null) {
                item.news_details_saved_date = dayjs(new Date(item.news_details_saved_date)).format('DD/MM/YYYY HH:mm:ss');
            }

            if(item.news_date !== undefined && item.news_date !== null) {
                item.news_date = dayjs(new Date(item.news_date)).format('DD/MM/YYYY HH:mm:ss');
            }
            
            let teams = ""
            let mSelectedTeams = []
            if (!isEmpty(item.team1)) {
                teams += item.team1;
                mSelectedTeams.push({ss_team_id: item.ss_team_id, name: item.team1})
            
                if (!isEmpty(item.team2)) {
                    teams += ', ';
                }
            }
            if (!isEmpty(item.team2)) {
                teams += item.team2;
                mSelectedTeams.push({ss_team_id: item.ss_team_id_2, name: item.team2})
            }
            if (item.ss_team_id === 0 || item.ss_team_id_2 == 0) {
                teams += 'Süper Lig Genel'
                mSelectedTeams.push({ss_team_id: 0, name: 'Süper Lig Genel'})
            }
            item.newsId = item.id
            item.selectedTeams = mSelectedTeams
            item.teams = teams

            return item
        },
        isSilenced(newsObject) {
            return newsObject.silenced
        },
        isRecentlyAdded(newsObject) {
            return !newsObject.is_news_collector && newsObject.added_automatically && (newsObject.news_details_saved_date === undefined || newsObject.news_details_saved_date === null)
        },
        isDetailsFailed(newsObject) {
            return !this.isRecentlyAdded(newsObject) && newsObject.added_automatically && newsObject.news_details_saved_date !== null
                && (
                    (!newsObject.has_pictures && (newsObject.content === null || newsObject.content === undefined))
                    || (newsObject.has_pictures && (newsObject.pictures === null || newsObject.pictures === undefined))
                )
        },
        isDetailsReady(newsObject) {
            return !this.isRecentlyAdded(newsObject) && !this.isDetailsFailed(newsObject)
        },
        setMenuRef(element, index) {
            if (element) {
                this.menuRefs[index] = element;
            }
        },
        toggleOptions(event, newsSource, newsObject, index) {
            let newsOptionsMenu = this.newsOptionsMenu

            newsOptionsMenu.selectedNewsSource = newsSource
            newsOptionsMenu.newsObject = newsObject
            newsOptionsMenu.index = index

            let optionsMenuItems = []

            optionsMenuItems.push(...[
                {
                    label: 'Add',
                    icon: 'pi pi-plus',
                    visible: newsSource !== 'slc' && !newsObject.isAddedBefore,
                    command: () => {
                        this.getNewsDetailsForInsert(newsSource, newsObject)
                    }
                },
                {
                    label: 'Edit',
                    icon: 'pi pi-pencil',
                    visible: newsSource === 'slc',
                    command: () => {
                        this.editNews(newsObject, index)
                    }
                },{
                    label: 'Delete',
                    icon: 'pi pi-trash',
                    visible: newsSource === 'slc',
                    command: () => {
                        this.deleteNews(newsObject.id)
                    }
                },{
                    label: 'Update details',
                    icon: 'pi pi-refresh',
                    visible: newsSource === 'slc' && newsObject.added_automatically,
                    command: () => {
                        this.updateNewsDetailsByNewsSource(this.newsOptionsMenu.newsObject.id, this.newsOptionsMenu.index)
                    }
                },{
                    label: 'Silence',
                    icon: 'fa fa-regular fa-bell-slash',
                    visible: !newsObject.silenced,
                    command: () => {
                        this.silenceNews(this.newsOptionsMenu.newsObject.id, this.newsOptionsMenu.index)
                    }
                }
            ])

            if(optionsMenuItems.length === 0) {
                optionsMenuItems = [
                    {
                        label: 'None available'
                    }
                ]
            }

            newsOptionsMenu.items = optionsMenuItems

            const menu = this.menuRefs[index];
            if (menu) { // Referansın bulunduğundan emin ol
                menu.toggle(event);
            } else {
                console.error(`Menu ref for index ${index} not found!`);
            }
        },
        async silenceNews(newsId, index) {
            let self = this,
                toast = self.$toast,
                token = self.$cookies.get('token');
            
            this.$confirm.require({
                message: 'Are you sure you want to silence this news?',
                header: 'Silence',
                icon: 'pi pi-volume-off',
                acceptLabel: 'Silence',
                rejectLabel: 'Cancel',
                accept: async () => {
                    try {
                        let response = await self.$http.post(`api/news/${newsId}/silence`, null, {
                            headers: {
                                'authorization': 'Bearer ' + token
                            }
                        })

                        if(!isEmpty(response.data.kod) && response.data.kod === Const.KOD.basarili && !isEmpty(response.headers['refresh-token'])) {
                            self.$cookies.set("token", response.headers['refresh-token']);

                            this.news.items[index] = self.prepareNewsItem(response.data.item)

                            toast.add({severity:'success', summary: 'Success', detail: 'News silenced successfully.', life: 1500});
                        } else {
                            console.log(response)
                            toast.add({severity:'warn', summary: 'News silence failed', detail:response.data.mesaj, life: 3000});
                        }
                    } catch (error) {
                        console.log(error)
                        toast.add({severity: 'error', summary: 'Error', detail: error});
                    }
                },
                reject: () => {}
            });
        },
        popupNewsInfo(newsObject) {
            this.popupNewsObject.visible = true
            this.popupNewsObject.item = newsObject
        },
        popupNewsAIContent(newsObject, index) {
            this.popupNewsObjectAiContent.visible = true
            this.popupNewsObjectAiContent.item = newsObject
            this.popupNewsObjectAiContent.index = index

            let diffSubtitle = diffWords(this.popupNewsObjectAiContent.item.original_subtitle, this.popupNewsObjectAiContent.item.ai_subtitle); 
            let diffSubtitleOutput = diffSubtitle.map(part => { 
                const styleName = part.added ? 'added-by-ai' : part.removed ? 'removed-by-ai' : 'normal-text';
                return `<span class="${styleName}">${part.value}</span>`; 
            }).join('');

            let diffContent = diffWords(this.popupNewsObjectAiContent.item.original_content, this.popupNewsObjectAiContent.item.ai_content); 
            let diffContentOutput = diffContent.map(part => { 
                const styleName = part.added ? 'added-by-ai' : part.removed ? 'removed-by-ai' : 'normal-text';
                return `<span class="${styleName}">${part.value}</span>`; 
            }).join('');

            this.popupNewsObjectAiContent.itemDiff.ai_subtitle = diffSubtitleOutput
            this.popupNewsObjectAiContent.itemDiff.ai_content = diffContentOutput
        },
        async popupSelectEvent() {
            let self = this,
                token = self.$cookies.get('token'),
                popupEventSelection = self.popupEventSelection
            
            popupEventSelection.visible = true

            let response = await self.$http.get(`api/ssevents/categories/${this.dateToYMD(popupEventSelection.date)}`, {
                headers: {
                    'authorization': 'Bearer ' + token
                }
            })
            
            popupEventSelection.categories = response.data.categories
        },
        eventImageEnabledChanged() {
            if (this.newsForm.event_image_enabled) {
                this.newsEventImage.selected = this.newsEventImage.items[0]
            } else {
                this.clearEventImageSelection()
            }
        },
        clearEventImageSelection() {
            this.newsEventImage.selected = {
                background_url: null
            }
        },
        getEventImage() {
            var eventImage = null
            if (this.newsEventImage.selected?.id !== undefined && this.newsEventImage.selected?.id !== null) {

                var tempEventImage = {}
                if (this.newsEventImage.selected?.id === 999) {
                    let backgroundUrl = this.newsEventImage.selected?.background_url
                    if (backgroundUrl === undefined || backgroundUrl === null || backgroundUrl === '') {
                        alert('Image URL can not be null');
                        return null;
                    }

                    tempEventImage.bu = backgroundUrl;
                } else {
                    tempEventImage.br = this.newsEventImage.selected?.id
                }

                if (this.popupEventSelection.selectedEvent === undefined || this.popupEventSelection.selectedEvent === null) {
                    alert('Event can not be null');
                    return null;
                }
                let event = this.popupEventSelection.selectedEvent

                tempEventImage.h = event.homeTeam?.id
                tempEventImage.a = event.awayTeam?.id
                tempEventImage.sid = event.id

                eventImage = tempEventImage
            }

            return eventImage
        },
        async popupEventCategoryChanged() {
            let self = this,
                token = self.$cookies.get('token'),
                popupEventSelection = self.popupEventSelection,
                selectedCategory = popupEventSelection.selectedCategory

            let response = await self.$http.get(`api/ssevents/category/${selectedCategory.category.id}/scheduled-events/${this.dateToYMD(popupEventSelection.date)}`, {
                headers: {
                    'authorization': 'Bearer ' + token
                }
            })

            response.data.events?.forEach(element => {
                element.event_info = `${element.homeTeam.name} - ${element.awayTeam.name}`
                if (element.homeScore !== undefined && element.homeScore !== null && element.homeScore.current !== undefined
                    && element.awayScore !== undefined && element.awayScore !== null && element.awayScore.current !== undefined) {
                    element.event_info = `${element.homeTeam.name} ${element.homeScore.current} - ${element.awayScore.current} ${element.awayTeam.name}`
                }
            });

            popupEventSelection.events = response.data.events
        },
        popupEventSave() {
            this.popupEventSelection.visible = false
        },
        popupEventClearSelection() {
            this.$confirm.require({
                message: 'Clear event selection for news?',
                header: 'Clear',
                icon: 'pi pi-times-circle',
                acceptLabel: 'Clear',
                rejectLabel: 'Cancel',
                accept: async () => {
                    this.popupEventSelection.selectedCategory = null
                    this.popupEventSelection.selectedEvent = null
                    this.popupEventSelection.events = null
                    this.popupEventSelection.visible = false

                    this.clearEventImageSelection()
                    this.newsForm.event_image_enabled = false
                },
                reject: () => {}
            });
        },
        popupCloseNewsDialog() {
            this.isNewsFormVisible = false
            this.clearEventImageSelection()
        },
        dateToYMD(date) {
            var d = date.getDate();
            var m = date.getMonth() + 1; //Month from 0 to 11
            var y = date.getFullYear();
            return '' + y + '-' + (m<=9 ? '0' + m : m) + '-' + (d <= 9 ? '0' + d : d);
        },
        getEventImagesList() {
            return [
                    { id: 1, name: '', path: 'images/event_images/event_image_bg_1.jpg' },
                    { id: 2, name: '', path: 'images/event_images/event_image_bg_2.jpg' },
                    { id: 3, name: '', path: 'images/event_images/event_image_bg_3.jpg' },
                    { id: 4, name: '', path: 'images/event_images/event_image_bg_4.jpg' },
                    { id: 5, name: '', path: 'images/event_images/event_image_bg_5.jpg' },
                    { id: 7, name: 'Şampiyonlar Ligi', path: 'images/event_images/event_image_bg_7.jpg' },
                    { id: 6, name: 'Avrupa Ligi', path: 'images/event_images/event_image_bg_6.jpg' },
                    { id: 8, name: 'Konferans Ligi', path: 'images/event_images/event_image_bg_8.jpg' },
                    { id: 999, name: 'Custom Background Url', path: null },
                ];
        },
        getEventImageObject(eventImage) {
            let images = this.getEventImagesList()
            if (eventImage.br !== undefined && eventImage.br !== null) {
                return images.find(image => image.id === eventImage.br)
            } else if (eventImage.bu !== undefined && eventImage.bu !== null) {
                let imageCustom = images.find(image => image.id === 999)
                imageCustom.background_url = eventImage.bu
                return imageCustom
            }

            return images[0]
        },
        getEventImageSrc(eventImage) {
            let imageSrc = null
            let images = this.getEventImagesList()
            if (eventImage.br !== undefined && eventImage.br !== null) {
                imageSrc = images.find(image => image.id === eventImage.br).path;
            } else if(eventImage.bu !== undefined && eventImage.bu !== null) {
                imageSrc = eventImage.bu
            } else {
                imageSrc = images[0].path
            }

            return imageSrc
        },
        getEventImageTeamLogoSrc(teamId) {
            return 'https://api.sofascore1.com/api/v1/team/'+teamId+'/image';
        },
        toggleAIContentInUse(newsObject, index, aiOrOriginal) {
            var confirmMessage = 'Do you want to enable AI news content in use?';
            if (aiOrOriginal === 'original') {
                confirmMessage = 'Do you want to show original news content in use?';
            }

            this.$confirm.require({
                message: confirmMessage,
                header: 'Toggle AI Content In Use',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: 'Toggle',
                rejectLabel: 'Cancel',
                accept: async () => {
                    try {
                        let response = await SpringApi.post(`/news/${newsObject.id}/switch-to/${aiOrOriginal}`);
                        console.log(response)
                        this.news.items[index].content = response.data.content;
                        this.news.items[index].subtitle = response.data.subtitle;
                        this.news.items[index].is_ai_content_in_use = response.data.isAiContentInUse;
                        this.popupNewsObjectAiContent.visible = false
                    } catch(error) {
                        console.log(error)
                    }
                },
                reject: () => {
                }
            });
        },
        showGalleryNewsPopup(newsObject, index) {
            this.popupGalleryNewsAiContent.visible = true
            this.popupGalleryNewsAiContent.item = newsObject
            this.popupGalleryNewsAiContent.index = index

            if (newsObject.pictures !== null && newsObject.pictures.length > 0) {
                newsObject.pictures.forEach((picture, index) => {
                    if ((picture.original_description !== null && picture.original_description !== '')
                        || (picture.ai_description !== null && picture.ai_description !== '')
                    ) {
                        let diffDescription = diffWords(picture.original_description, picture.ai_description); 
                        let diffDescriptionOutput = diffDescription.map(part => { 
                            const styleName = part.added ? 'added-by-ai' : part.removed ? 'removed-by-ai' : 'normal-text';
                            return `<span class="${styleName}">${part.value}</span>`; 
                        }).join('');
                        console.log(diffDescriptionOutput);
            
                        this.popupGalleryNewsAiContent.item.pictures[index].itemDiff = diffDescriptionOutput
                    } else {
                        this.popupGalleryNewsAiContent.item.pictures[index].itemDiff = 'N/A';
                    }
                })
            }

        }
    },
    computed: {
        showCreateButton() {
            return this.selectedNewsSource === Const.NewsSource.SLC
        },
        showCreateNotificationButton(news) {
            var show = this.mode === 'add' || !news.has_notification

            return show
        }
    }
}

</script>
